"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var ModalV2_1 = __importDefault(require("@src/components/ModalV2"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var text_2 = __importDefault(require("relements/build/esm/input/text"));
var checkbox_1 = __importDefault(require("relements/build/esm/input/checkbox"));
var dropdown_1 = __importDefault(require("relements/build/esm/input/dropdown"));
var button_1 = __importDefault(require("relements/build/esm/ui/button"));
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var FIELD_TYPE_OPTIONS = [
    { id: '0', name: 'no type' },
    { id: '1', name: 'string' },
    { id: '2', name: 'number' },
    { id: '3', name: 'boolean' },
    { id: '4', name: 'array' },
];
var MergeModal = function (_a) {
    var _b;
    var active = _a.active, closeModal = _a.closeModal, data = _a.data, setData = _a.setData, onChange = _a.onChange, metaColumns = _a.metaColumns, onUndo = _a.onUndo;
    var _c = react_1.useState({}), selectedColumns = _c[0], setSelectedColumns = _c[1];
    var _d = react_1.useState(''), delimiter = _d[0], setDelimiter = _d[1];
    var _e = react_1.useState('no type'), dataType = _e[0], setDataType = _e[1];
    var _f = react_1.useState(''), columnName = _f[0], setColumnName = _f[1];
    var _g = react_1.useState(null), originalFieldName = _g[0], setOriginalFieldName = _g[1];
    // Initialize form from data when modal opens with existing merge action
    react_1.useEffect(function () {
        if (active &&
            data &&
            'mergedFrom' in data &&
            'originalMergeAction' in data) {
            var mergeAction = data.originalMergeAction;
            if (mergeAction) {
                // Initialize selectedColumns based on mergedFrom
                var newSelectedColumns_1 = {};
                if ('mergedFrom' in data && data.mergedFrom) {
                    data.mergedFrom.forEach(function (col) {
                        newSelectedColumns_1[col] = true;
                    });
                    // Store the original field name (first merged column) for undo
                    setOriginalFieldName(data.mergedFrom[0]);
                }
                setSelectedColumns(newSelectedColumns_1);
                setDelimiter(mergeAction.delimiter || '');
                setColumnName(mergeAction.final_name || '');
                setDataType(mergeAction.final_type || 'no type');
            }
        }
        else if (active && !data) {
            // Reset form when opening for new merge
            setSelectedColumns({});
            setDelimiter('');
            setColumnName('');
            setDataType('no type');
            setOriginalFieldName(null);
        }
    }, [active, data]);
    var handleClose = function () {
        setData(null);
        setOriginalFieldName(null);
        closeModal();
    };
    var handleMerge = function () {
        var action = {
            action: 'merge',
            merge_with: [],
            delimiter: delimiter,
            final_name: columnName,
            final_type: dataType,
        };
        var firstField = selectedColumns ? Object.keys(selectedColumns)[0] : '';
        Object.entries(selectedColumns).forEach(function (_a, index) {
            var column = _a[0], value = _a[1];
            if (index === 0)
                return;
            if (value) {
                action.merge_with.push(column);
            }
        });
        onChange(firstField, action);
        handleClose();
    };
    return (react_1["default"].createElement(ModalV2_1["default"], { title: "Merge Columns", subtitle: "", headerIcon: null, headerSubIcon: null, active: active, classPrefix: "mergeModal", isV2: true, toggleModal: handleClose },
        react_1["default"].createElement(text_1["default"], { variant: "h4.semi-bold" }, "Select columns to merge"),
        react_1["default"].createElement(box_1["default"], { flexDirection: "column", height: "25vh", overflow: "auto" }, metaColumns.map(function (column) {
            var _a;
            return (react_1["default"].createElement(box_1["default"], { padding: "0", mt: "8px", onClick: function () {
                    setSelectedColumns(function (prev) {
                        var updatedSelectedColumns = structuredClone(prev);
                        updatedSelectedColumns[column] = !updatedSelectedColumns[column];
                        if (updatedSelectedColumns[column] === false) {
                            delete updatedSelectedColumns[column];
                        }
                        return updatedSelectedColumns;
                    });
                } },
                react_1["default"].createElement(checkbox_1["default"].Item, { themed: true, value: (_a = selectedColumns[column]) !== null && _a !== void 0 ? _a : false }),
                react_1["default"].createElement(text_1["default"], { variant: "body.md", style: {
                        wordBreak: 'break-word',
                        marginLeft: '-12px',
                        cursor: 'pointer',
                    } }, column)));
        })),
        react_1["default"].createElement(box_1["default"], { padding: "0", pb: "4px", flexDirection: "column", mt: "16px" },
            react_1["default"].createElement(text_1["default"], { variant: "body.md" }, "Delimiter"),
            react_1["default"].createElement(text_2["default"], { themed: true, placeholder: "Enter the delimiter", className: "delimiter", value: delimiter, onChange: function (val) { return setDelimiter(val); }, style: { margin: '8px 0 16px' } }),
            react_1["default"].createElement(text_1["default"], { variant: "body.md" }, "New Field Name"),
            react_1["default"].createElement(box_1["default"], { padding: "0", justifyContent: "space-between", alignItems: "center", margin: "8px 0", style: { gap: '8px' } },
                react_1["default"].createElement(text_2["default"], { themed: true, placeholder: "Enter the field name", value: columnName, onChange: function (val) { return setColumnName(val.trim()); } }),
                react_1["default"].createElement(dropdown_1["default"], { themed: true, options: FIELD_TYPE_OPTIONS, optionKey: "name", value: (_b = FIELD_TYPE_OPTIONS.find(function (opt) { return opt.name === dataType; })) !== null && _b !== void 0 ? _b : FIELD_TYPE_OPTIONS[0], onChange: function (option) {
                        if (option === null || option === void 0 ? void 0 : option.name) {
                            setDataType(option.name);
                        }
                    }, style: { width: '48%' }, inputStyles: { marginTop: '-6px' }, optionsStyle: { zIndex: 1000000010 } }))),
        react_1["default"].createElement(box_1["default"], { padding: "0", justifyContent: "space-between", margin: "auto 0 12px" },
            react_1["default"].createElement(button_1["default"], { themed: true, variant: "secondary", style: { width: originalFieldName && onUndo ? '32%' : '48%' }, onClick: handleClose }, "Cancel"),
            originalFieldName && onUndo && (react_1["default"].createElement(button_1["default"], { themed: true, variant: "secondary", style: { width: '32%' }, onClick: function () {
                    onUndo(originalFieldName);
                    handleClose();
                } }, "Undo")),
            react_1["default"].createElement(button_1["default"], { themed: true, variant: "primary", style: { width: originalFieldName && onUndo ? '32%' : '48%' }, onClick: handleMerge }, "Apply Merge"))));
};
exports["default"] = MergeModal;
